import {AcademyStudent, INCOMPLETE_STUDENT_FLAG} from "@/app/types/Student";
import clsMerge from "@/app/util/clsMerge";

export type StudentNameClasses = {
	completeStudentRoot?: string;
	incompleteStudentRoot?: string;
	incompleteStudentText?: string;
};

interface StudentNameProps extends AcademyStudent {
	classes?: StudentNameClasses;
}

const StudentName: React.FC<StudentNameProps> = ({
	firstName,
	lastName,
	classes,
}) => {
	if (lastName !== INCOMPLETE_STUDENT_FLAG) {
		return (
			<div
				className={clsMerge(classes?.completeStudentRoot)}
			>{`${firstName} ${lastName}`}</div>
		);
	}

	return (
		<div
			className={clsMerge(
				"flex flex-row gap-2",
				classes?.incompleteStudentRoot
			)}
		>
			{firstName}
			<span
				className={clsMerge(
					"italic text-semantic-error-300",
					classes?.incompleteStudentText
				)}
			>
				(Incomplete)
			</span>
		</div>
	);
};

export default StudentName;
